let pending: Promise<string[]> | undefined;

/** Load the embedded images only on demand and wait until every image can be painted. */
export const loadServiceLogos = (): Promise<string[]> => {
  pending ??= import(/* webpackChunkName: "service-logos" */ "./serviceLogos")
    .then(async ({ getServiceLogos }) => {
      const logos = getServiceLogos();

      if (!logos.length) {
        throw new Error("No service logos available");
      }

      await Promise.all(
        logos.map(async (src) => {
          const image = new Image();
          image.src = src;
          await image.decode();
        }),
      );

      return logos;
    })
    .catch((error: unknown) => {
      pending = undefined;
      throw error;
    });

  return pending;
};
